<template src="./ComplexCaseSolution.html"></template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import DatePicker from "@/components/DatePicker";
import { Case } from "@/models/cases/Case";
import { ComplexSolveDTO } from "@/models/solution/ComplexSolveDTO";
import BaseButton from "@/components/BaseButton";
import { solutionModule } from "@/store/modules/solution";
import { SolutionGetters } from "@/store/modules/solution/getters";
import * as caseSources from "@/consts/caseSources";
import CaseSolutionInput from "./CaseSolutionInput";
import solutionValidationService from "@/services/solutionValidationService";
import NotificationDialog from "@/components/NotificationDialog";
import validationRules from "@/services/validationRules";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    components: {
        DatePicker,
        BaseButton,
        CaseSolutionInput,
        NotificationDialog
    },
    emits: ["solve"],
    props: { caseModel: { type: Object as PropType<Case>, required: true } },
    computed: {
        ...solutionModule.mapGetters({ loading: SolutionGetters.Loading }),
        isBoardCase(): boolean {
            return (
                this.caseModel?.source?.name?.toUpperCase() ===
                caseSources.BOARD.toUpperCase()
            );
        }
    },
    methods: {
        validateAdditionalFields(): boolean {
            if (this.isBoardCase) {
                this.datePickerError = !this.solveData.finalReplyDate;
                return !this.datePickerError;
            }
            return true;
        },
        async submit(): Promise<void> {
            let result = this.validateAdditionalFields();
            result &&= (await (this.$refs.form as VForm).validate()).valid;
            result &&= this.solveData.solutions !== undefined;
            this.solveData.solutions?.forEach((solution) => {
                result &&= solutionValidationService.validate(solution);
            });
            if (result) this.$emit("solve", this.solveData);
            else this.validationErrorVisible = true;
        }
    },
    created() {
        const codeLevelSets = [...this.caseModel.codeLevelSets];
        this.solveData.solutions = codeLevelSets
            .sort((a, b) => a.order - b.order)
            .map((cs) => ({
                caseId: this.caseModel.caseId,
                caseCodeLevelSetId: cs.caseCodeLevelSetId
            }));
    },
    data() {
        return {
            solveData: { solutions: [] } as Partial<ComplexSolveDTO> &
                Pick<ComplexSolveDTO, "solutions">,
            validationErrorVisible: false,
            datePickerError: false,
            vinRules: [validationRules.required("VIN")]
        };
    }
});
</script>
